/**
 * TTS 读法修正工具，用于在语音合成前替换专有名词的读法
 * （与 speechCorrection.ts 相反：这里是「合成前」修正读音，那边是「识别后」纠错文本）
 *
 * 说明：
 * - 替换发生在 getTTS 发送请求之前，仅影响送往 TTS 服务的文本，不影响画面上显示的消息内容
 * - pattern 使用正则时注意加 g 标志；纯英文缩写建议用 \b 词边界 + i 忽略大小写
 */

interface PronunciationRule {
  pattern: RegExp;
  replacement: string;
}

/**
 * 读法替换规则表
 * 无语言限制，对所有 TTS 请求生效
 * （部分调用点不传 lang，如 ChatContent 整段朗读按钮，因此不能按语言过滤）
 */
const PRONUNCIATION_RULES: PronunciationRule[] = [
  // 「akjs」应读作「エーケージェイエス」（客户反馈：2026-07）
  { pattern: /\bakjs\b/gi, replacement: 'エーケージェイエス' },
];

/**
 * 在语音合成前修正文本中专有名词的读法
 * @param text 待合成的原始文本
 * @returns 替换读法后的文本
 */
export const correctTTSPronunciation = (text: string): string => {
  let correctedText = text;

  for (const rule of PRONUNCIATION_RULES) {
    // 直接 replace（带 g 标志的 replace 会从头匹配全部出现位置，无 lastIndex 状态问题）
    correctedText = correctedText.replace(rule.pattern, rule.replacement);
  }

  return correctedText;
};
